import { render, staticRenderFns } from "./AccordionListEditor.vue?vue&type=template&id=0e455a2f&scoped=true"
import script from "./AccordionListEditor.vue?vue&type=script&lang=js"
export * from "./AccordionListEditor.vue?vue&type=script&lang=js"
import style0 from "./AccordionListEditor.vue?vue&type=style&index=0&id=0e455a2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e455a2f",
  null
  
)

export default component.exports